var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9196 2.09082H1.37674C1.01337 2.09082 0.718811 2.38538 0.718811 2.74875V16.7674C0.718811 17.1308 1.01337 17.4253 1.37674 17.4253H17.9196C18.283 17.4253 18.5776 17.1308 18.5776 16.7674V2.74875C18.5776 2.38538 18.283 2.09082 17.9196 2.09082Z",
    stroke: "#505050",
    strokeWidth: 1.01563,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90386 7.40039H3.95816C3.5948 7.40039 3.30023 7.69495 3.30023 8.05832V10.004C3.30023 10.3674 3.5948 10.6619 3.95816 10.6619H5.90386C6.26723 10.6619 6.56179 10.3674 6.56179 10.004V8.05832C6.56179 7.69495 6.26723 7.40039 5.90386 7.40039Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6208 7.40039H8.67508C8.31171 7.40039 8.01715 7.69495 8.01715 8.05832V10.004C8.01715 10.3674 8.31171 10.6619 8.67508 10.6619H10.6208C10.9841 10.6619 11.2787 10.3674 11.2787 10.004V8.05832C11.2787 7.69495 10.9841 7.40039 10.6208 7.40039Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3378 7.40039H13.3921C13.0287 7.40039 12.7341 7.69495 12.7341 8.05832V10.004C12.7341 10.3674 13.0287 10.6619 13.3921 10.6619H15.3378C15.7011 10.6619 15.9957 10.3674 15.9957 10.004V8.05832C15.9957 7.69495 15.7011 7.40039 15.3378 7.40039Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90386 11.8857H3.95816C3.5948 11.8857 3.30023 12.1803 3.30023 12.5437V14.4894C3.30023 14.8527 3.5948 15.1473 3.95816 15.1473H5.90386C6.26723 15.1473 6.56179 14.8527 6.56179 14.4894V12.5437C6.56179 12.1803 6.26723 11.8857 5.90386 11.8857Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6208 11.8857H8.67508C8.31171 11.8857 8.01715 12.1803 8.01715 12.5437V14.4894C8.01715 14.8527 8.31171 15.1473 8.67508 15.1473H10.6208C10.9841 15.1473 11.2787 14.8527 11.2787 14.4894V12.5437C11.2787 12.1803 10.9841 11.8857 10.6208 11.8857Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3377 11.8857H13.392C13.0286 11.8857 12.7341 12.1803 12.7341 12.5437V14.4894C12.7341 14.8527 13.0286 15.1473 13.392 15.1473H15.3377C15.7011 15.1473 15.9956 14.8527 15.9956 14.4894V12.5437C15.9956 12.1803 15.7011 11.8857 15.3377 11.8857Z",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.718811 5.75781H18.5776",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60365 0.384766H5.11941C4.75605 0.384766 4.46149 0.679329 4.46149 1.04269V3.79282C4.46149 4.15619 4.75605 4.45075 5.11941 4.45075H5.60365C5.96701 4.45075 6.26157 4.15619 6.26157 3.79282V1.04269C6.26157 0.679329 5.96701 0.384766 5.60365 0.384766Z",
    fill: "white",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1769 0.384766H13.6927C13.3294 0.384766 13.0348 0.679329 13.0348 1.04269V3.79282C13.0348 4.15619 13.3294 4.45075 13.6927 4.45075H14.1769C14.5403 4.45075 14.8349 4.15619 14.8349 3.79282V1.04269C14.8349 0.679329 14.5403 0.384766 14.1769 0.384766Z",
    fill: "white",
    stroke: "#505050",
    strokeWidth: 0.677083,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpp);
export default __webpack_public_path__ + "static/media/opp.7eb78edd43f0a131d8e4c0b21230c9b1.svg";
export { ForwardRef as ReactComponent };